export default __webpack_public_path__ + "static/media/live-updates-food.c2979146.svg";